import React, {useEffect, useState} from "react";
import api from "../api/axiosInstance";
import ProductFormModal from "../components/ProductFormModal";

const TeeLaunchProductsPage = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({
        category: "",
        subcategory: "",
        price: "",
        quantity: "",
        alttext: "",
        details: "",
        tags: "",
        supplier: "TeeLaunch",
        isFeatured: false,
        newProduct: true,
        variants: {},
    });

    useEffect(() => {
        fetchProducts();
    }, []);

    const fetchProducts = async () => {
        try {
            const res = await api.get("/admin/products/teelaunch");
            console.log(res.data.products);
            setProducts(res.data.products || []);
        } catch (err) {
            setError(err.response?.data?.error || err.message);
        } finally {
            setLoading(false);
        }
    };

    const getProductMaxCost = (product) => {
        if (!product?.variants?.length) return "0.00";
        const costs = product.variants.map((v) => parseFloat(v.price) || 0);
        return Math.max(...costs).toFixed(2);
    };

    const getVariantKey = (v, idx) => v.sku ?? v.id ?? String(idx);

    const openAddModal = (product) => {
        const variantDefaults = {};
        product.variants.forEach((v, idx) => {
            const key = getVariantKey(v, idx);
            variantDefaults[key] = true;
        });

        setSelectedProduct(product);

        setFormData({
            category: "",
            subcategory: "",
            price: product.variants?.[0]?.price ?? "",
            description: product.description,
            quantity: "",
            alttext: product.title ?? "",
            details: "",
            tags: "",
            supplier: "TeeLaunch",
            supplierId: product.sku,
            isFeatured: false,
            newProduct: true,
            variants: variantDefaults,
        });
        setShowModal(true);
    };

    const buildModalProduct = (product, formData) => {
        const detailsArray = formData.details
            ? formData.details.split("\n").map((s) => s.trim()).filter(Boolean)
            : [];
        const tagsArray = formData.tags
            ? formData.tags.split(",").map((s) => s.trim()).filter(Boolean)
            : [];

        const variants = product.variants.map((v, idx) => {
            const key = getVariantKey(v, idx);
            const selected = !!formData.variants[key];
            return {
                id: key,
                sku: v.sku ?? "",
                title: v.title,
                price: Number(v.price),
                quantity: v.quantity ?? 0,
                image: v.images ?? product.images ?? [],
                selected,
            };
        });

        const productImages = product.images;

        return {
            image: productImages,
            alttext: formData.alttext || product.title || "",
            title: product.title,
            description: formData.description || product.title || "",
            details: detailsArray,
            isFeatured: !!formData.isFeatured,
            price: Number(formData.price) || 0,
            sku: product.sku,
            variants,
            supplier: formData.supplier || "TeeLaunch",
            quantity: parseInt(formData.quantity, 10) || 0,
            tags: tagsArray,
            category: formData.category || "Uncategorized",
            subcategory: formData.subcategory || "General",
            newProduct: !!formData.newProduct,
        };
    };

    const handleModalSubmit = async (data) => {
        try {
            await api.post("/admin/products", data);
            setShowModal(false);
            fetchProducts();
        } catch (err) {
            alert("Failed to add product: " + (err.response?.data?.error || err.message));
        }
    };

    if (loading) return <p className="p-4">Loading products…</p>;
    if (error) return <p className="p-4 text-red-600">Error: {error}</p>;

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">TeeLaunch Products</h1>
            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {products.map((p) => (
                    <div key={p.sku} className="border rounded-lg shadow p-4 flex flex-col items-center">
                        {p.images?.[0] && (
                            <img src={p.images[0]} alt={p.title} className="w-40 h-40 object-contain mb-4"/>
                        )}
                        <h2 className="text-lg font-semibold text-center">{p.title}</h2>
                        <p className="text-gray-600 text-sm mb-2">{p.variants.length} variants</p>
                        <p className="text-xs text-gray-400 mb-2">SKU: {p.sku}</p>
                        <p className="text-gray-800 font-semibold mb-2">Cost: ${getProductMaxCost(p)}</p>
                        <div className="flex gap-2">
                            <button
                                className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                                onClick={() => openAddModal(p)}
                            >
                                Add to Storefront
                            </button>
                        </div>
                    </div>
                ))}
            </div>
            <ProductFormModal
                open={showModal}
                onClose={() => setShowModal(false)}
                product={selectedProduct ? buildModalProduct(selectedProduct, formData) : null}
                onSubmit={handleModalSubmit}
            />
        </div>
    );
};

export default TeeLaunchProductsPage;
